import { IconButton, OdinIconName, OdinIconSize } from '@myosh/odin-components';
import { t } from 'i18next';
import { ReactNode, useMemo, useRef, useState } from 'react';
import { AboutMenuOption } from './about-menu-component';

type MenuItem = {
  title: string;
  isSupported: boolean;
  clickHandler?: () => void;
  className: string;
  icon: OdinIconName;
  iconSize: OdinIconSize;
  component: ReactNode;
};

interface MenuOptionsProps {
  closeConfigOverlay: () => void;
}

export const MenuOptionsComponent = ({ closeConfigOverlay }: MenuOptionsProps) => {
  const itemStyle = useRef<string>(
    `text-sm flex items-center whitespace-nowrap px-3 leading-5 cursor-pointer hover:bg-primary-4 text-mono-0`
  );
  const [aboutModelVisible, setAboutModelVisible] = useState<boolean>(false);

  const menuOptions: MenuItem[] = useMemo(
    () => [
      {
        title: t('about'),
        isSupported: true,
        icon: 'Info',
        iconSize: OdinIconSize.ExtraSmall,
        clickHandler: () => setAboutModelVisible(true),
        className: itemStyle.current,
        component: <AboutMenuOption showAboutInfo={aboutModelVisible} setShowAboutInfo={setAboutModelVisible} />,
      },
    ],
    [aboutModelVisible]
  );

  return (
    <div className="w-42 flex flex-col flex-wrap bg-mono-1 py-2 shadow group-hover:flex">
      {menuOptions.map(
        (option) =>
          option.isSupported && (
            <div
              key={option.title}
              className={option.className}
              onClick={() => {
                if (option.clickHandler) {
                  option.clickHandler();
                }
                closeConfigOverlay();
              }}
            >
              <IconButton classNames="mr-2" icon={option.icon} iconSize={option.iconSize} />
              {option.title}
              {option.component}
            </div>
          )
      )}
    </div>
  );
};
